import { render, staticRenderFns } from "./CombinationsConfiguratorCanvas.vue?vue&type=template&id=7f7ad0fc&scoped=true"
import script from "./CombinationsConfiguratorCanvas.vue?vue&type=script&setup=true&lang=ts"
export * from "./CombinationsConfiguratorCanvas.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f7ad0fc",
  null
  
)

export default component.exports